import * as Sentry from '@sentry/vue'

let lastErrorMessage = ''

export const captureAllErrors = () => {
  window.addEventListener('error', (event) => {
    const error = event?.error || event
    const message = error?.message || JSON.stringify(error)

    if (message === lastErrorMessage) return
    lastErrorMessage = message

    Sentry.addBreadcrumb({
      category: 'error',
      message,
      level: 'error',
    })

    Sentry.captureException(error, {
      tags: { source: 'frontend' },
    })
  })

  window.addEventListener('unhandledrejection', async ({ reason }) => {
    const message = reason?.message || JSON.stringify(reason)

    if (message === lastErrorMessage) return
    lastErrorMessage = message

    Sentry.addBreadcrumb({
      category: 'unhandledrejection',
      message,
      level: 'error',
    })

    if (
      reason instanceof Response &&
      (reason.status === 401 || reason.status >= 500)
    ) {
      const error = new Error(
        `Backend error: ${reason.status} ${reason.statusText}`
      )
      Sentry.captureException(error, {
        tags: {
          source: 'backend',
          status: reason.status.toString(),
        },
        extra: {
          url: reason.url,
        },
      })
      return
    }

    if (
      reason?.response instanceof Response &&
      (reason.response.status === 401 || reason.response.status >= 500)
    ) {
      const res = reason.response
      const eventId = Sentry.captureException(reason, {
        tags: {
          source: 'backend',
          status: res.status.toString(),
        },
        extra: {
          url: res.url,
        },
      })
      console.log('Captured Sentry event (wrapped backend error):', eventId)
      return
    }

    Sentry.captureException(reason, {
      tags: { source: 'frontend' },
    })
  })
}
